import {Button} from 'antd'
import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'

export default function PropertiesPaneButtonGenerateRam(props) {
    const map = useMapContext()
    const {prjId, sVer} = map.data
    const selectedNodes = map.useSelectedNodes()

    const nodes = [...selectedNodes].filter(n => {
        const {pkid, prjId: _prjId, sVer: _sVer} = n.data

        return (
            pkid &&
            _prjId === prjId &&
            _sVer === sVer
        )
    })

    if (0 === nodes.length) {
        return null
    }

    const onClick = () => {
        const fmIds = []
        const fmNames = []

        for (const n of nodes) {
            const {fmName, pkid} = n.data
            fmIds.push(pkid)
            fmNames.push(fmName)
        }

        openWindow(
            '/Ai',

            {
                bizMap: {fmIds},
                prjId,
                scene: 'GENERATE_RAM',
                sVer,
                title: `功能域: ${fmNames.join(', ')}`,
            }
        )
    }

    return (
        <Button
            onClick={onClick}
            {...props}
        >
            AI分析建模
        </Button>
    )
}
